import { useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useFeatureCookieName } from '../useFeatureCookieName';
/**
 * A hook to determine if a feature flag is enabled based on the URL query string.
 *
 * > Note 1: Uses a cookie to "remember" that setting.
 *
 * > Note 2: This **does not** do API feature flagging.
 *
 * @deprecated use [useIsFeatureFlagEnabled](./useIsFeatureFlagEnabled.ts) for
 * a more complete feature flag solution.
 */
export const useIsUrlFeatureFlagEnabled = (featureName) => {
    // This code checks whether a query string parameter exists and if it does, sets a cookie with the same value.
    // featureName is a string that represents the name of the feature.
    // featureQueryString is a string that represents the value of the query string parameter.
    const { search } = useLocation();
    const [cookies, setCookie] = useCookies();
    const queryStrings = new URLSearchParams(search);
    /** The name of the cookie this feature will be stored in. */
    const featureCookieName = useFeatureCookieName(featureName);
    /** The state of this feature flag in search params. */
    const featureQueryString = queryStrings.get(featureName);
    /** The state of this feature flag in cookies. */
    const featureCookie = cookies[featureCookieName];
    /** Returns true if this feature's query string exists and is not null. */
    const hasFeatureQueryString = featureQueryString !== null;
    /** Returns true if this feature's cookie state matches its query string state. */
    const isMatchBetweenCookieAndUrl = featureCookie === featureQueryString;
    if (hasFeatureQueryString && !isMatchBetweenCookieAndUrl) {
        // if the feature query string is not null, and it does not match the feature cookie
        // update the cookie
        setCookie(featureCookieName, featureQueryString, { path: '/' });
    }
    // if the feature query string is not null, use it
    // otherwise, use the feature cookie
    if (hasFeatureQueryString) {
        return featureQueryString === 'true';
    }
    return featureCookie === 'true';
};
